import { BaseEntity, getCachedStructureEntity } from ".";
import { IGet_characters_character_id_clones_ok } from "../service/esiclient";
import moment from "moment";
import { getCachedStationEntity } from "./StationEntityCache";
import { getCachedCharacterEntity } from "./CharacterEntityCache";
import { getCachedTypeEntity } from "./TypeEntityCache";

export class CloneEntity extends BaseEntity {
  constructor(id: number, props: any, character_id: any) {
    super(id, props);
    this._dataTypeName = "Character Clone Summary";
    this._character_id = character_id;
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const props: Partial<IGet_characters_character_id_clones_ok> = this.props;
    var entity = await super.toJson();
    // Properties
    if (entity.properties) {
      const characterEntity = await getCachedCharacterEntity(this._character_id);
      if (characterEntity !== null) {
        entity.properties["owner"] = await characterEntity.toJson();
      }
      if (props.last_clone_jump_date) {
        const last_jumped = moment(props.last_clone_jump_date);
        entity.properties["last_clone_jump_date"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: last_jumped.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      if (props.last_station_change_date) {
        const last_station_change_date = moment(props.last_station_change_date);
        entity.properties["last_station_change_date"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: last_station_change_date.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }

      if (props.home_location?.location_id) {
        const stationEntity = await getCachedStationEntity(props.home_location.location_id);
        if (stationEntity !== null) {
          entity.properties["home_location"] = await stationEntity.toJson(true);
        } else {
          const structureEntity = await getCachedStructureEntity(props.home_location.location_id, this._character_id);
          if (structureEntity !== null) {
            entity.properties["home_location"] = await structureEntity.toJson(true);
          }
        }
      }
      let clone_array: Excel.CellValue[][] = [];
      if (props.jump_clones && props.jump_clones.length) {
        for (const i of props.jump_clones) {
          let implant_array: Excel.CellValue[][] = [];
          if (i.implants.length) {
            for (const y of i.implants) {
              const typeEntity = await getCachedTypeEntity(y);
              if (typeEntity) {
                implant_array.push([
                  {
                    type: Excel.CellValueType.entity,
                    text: `${typeEntity.props["name"]}`,
                    properties: {
                      type: await typeEntity.toJson(),
                    },
                  },
                ]);
              } else {
                implant_array.push([
                  {
                    type: Excel.CellValueType.entity,
                    text: `Implant ${y}`,
                    properties: {
                      type_id: {
                        type: Excel.CellValueType.double,
                        basicValue: y,
                      },
                    },
                  },
                ]);
              }
            }
          }
          var implant_element: Excel.EntityPropertyType = {
            type: Excel.CellValueType.array,
            elements: implant_array,
          };
          var implant_false_element: Excel.EntityPropertyType = {
            type: Excel.CellValueType.boolean,
            basicValue: false,
          };
          const cloneStationEntity = await getCachedStationEntity(i.location_id);
          let clone_location_id: Excel.EntityPropertyType = {
            type: Excel.CellValueType.double,
            basicValue: i.location_id,
          };
          let clone_location_id_entity = null;
          let locname = i.location_id.toString();
          if (cloneStationEntity !== null) {
            clone_location_id_entity = await cloneStationEntity.toJson(true);
            if (clone_location_id_entity.text) {
              locname = clone_location_id_entity.text;
            }
          } else {
            const structureEntity = await getCachedStructureEntity(i.location_id, this._character_id);
            if (structureEntity !== null) {
              clone_location_id_entity = await structureEntity.toJson(true);
              if (clone_location_id_entity.text) {
                locname = clone_location_id_entity.text;
              }
            }
          }
          clone_array.push([
            {
              type: Excel.CellValueType.entity,
              text: `Clone with ${i.implants.length} implants in ${locname}`,
              properties: {
                jump_clone_id: {
                  type: Excel.CellValueType.double,
                  basicValue: i.jump_clone_id,
                },
                location: clone_location_id_entity != null ? clone_location_id_entity : clone_location_id,
                location_id: clone_location_id,
                location_type: {
                  type: Excel.CellValueType.string,
                  basicValue: i.location_type,
                },
                implant_count: {
                  type: Excel.CellValueType.double,
                  basicValue: i.implants.length,
                },
                implants: i.implants.length ? implant_element : implant_false_element,
              },
            },
          ]);
        }
        entity.properties["jump_clones"] = {
          type: Excel.CellValueType.array,
          elements: clone_array,
        };
      }

      delete entity.properties["id"];
      const charEnt = entity.properties["owner"] as Excel.EntityCellValue;
      if (charEnt && charEnt.properties) {
        const char_name = charEnt.properties.name.basicValue as string;
        const jump_clone_count = props.jump_clones != undefined ? props.jump_clones.length : 0;
        entity.text = char_name + " has " + jump_clone_count + " clone" + (jump_clone_count > 1 ? "s" : "");
      } else {
        entity.text = "Clones for " + this._character_id;
      }
      entity.properties["name"] = {
        type: Excel.CellValueType.string,
        basicValue: entity.text,
      };
    }
    // Layouts
    entity.layouts = {
      card: {
        title: { property: "name" },
      },
    };

    return entity;
  }
}
